import { useEffect } from 'react';
import { useQuery } from 'react-query';
import restFactory from 'v2/utils/restFactory';
import { CustomTab, DrmPage, DjangoListResponse } from 'v2/models';

export default function useGetCustomTab(drm_page: DrmPage) {
  const query = useQuery(
    ['useGetCustomTabs', drm_page],
    async () => {
      return await restFactory.get<DjangoListResponse<CustomTab>>(
        `/dj/api/v1/custom_tab/`,
        { drm_page }
      );
    },
    {
      cacheTime: 0,
      refetchOnWindowFocus: false,
      enabled: false,
    }
  );

  useEffect(() => {
    if (!drm_page) {
      query.remove();
    } else {
      query.refetch();
    }
  }, [drm_page]);

  return query;
}
